import {
  Button,
  createStyles,
  Grid,
  makeStyles,
  TableContainer,
  TableHead,
  TableBody,
  Tabs,
} from "@material-ui/core";
import React from "react";
import BaseLayout from "../../components/BaseLayout/BaseLayout";
import ButtonExport from "../../components/Filters/ButtonExport";
import DatePickerFilter from "../../components/Filters/Datepicker";
import SearchFilter from "../../components/Filters/SearchFilter";
import { formatCurrency } from "../../components/Utils/Currency";
import {
  ListPanel,
  ListPanelHasRelease,
  ListPanelLoading,
} from "./parts/ListPanel";
import MyIncomeStore from "./store";
import {
  StyledTable,
  StyledTableCell,
  StyledTableRow,
} from "../../components/CustomStyles/CustomTable";
import history from "../../History/History";
import {
  StyledPaperTabs,
  StyledTab,
} from "../../components/CustomStyles/CustomTabs";
import DateRangePickerFilter from "../../components/Filters/DateRangePicker";
import moment from "moment-timezone";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      width: "100%",
    },
    paper1: {
      marginTop: 15,
      backgroundColor: theme.palette.background.paper,
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary,
    },
    buttonDownload: {
      border: "0",
      cursor: "pointer",
      backgroundColor: "transparent",
    },
    headerPages: {
      fontWeight: 700,
      color: "#212121",
      fontSize: 16,
    },
    paper: {
      padding: "20px",
      width: 255,
      height: 148,
      borderRadius: 8,
    },
    smallPaper: {
      padding: "20px",
      width: 255,
      height: 70,
      borderRadius: 8,
    },
  })
);

const MyIncome = (props) => {
  const access = props.params;
  const classes = useStyles();
  const [myIncomeState, myIncomeActions] = MyIncomeStore();
  const [tabActive, setTabActive] = React.useState(0);
  const [expanded, setExpanded] = React.useState(false);
  const [search, setSearch] = React.useState("");
  const prevTabActive = usePreviousTab(tabActive);

  let today = moment(new Date()).format("YYYY-MM-DD") + " 23:59:59";
  let tStart = moment(new Date().setMonth(-1)).tz("UTC").format();
  let tEnd = moment(today).tz("UTC").format();
  const [dateRange, setDateRange] = React.useState({
    startDate: tStart,
    endDate: tEnd,
    key: "",
  });

  let arrProcess = [
    {
      status: "new",
      label: "Akan Dilepaskan",
    },
    {
      status: "process",
      label: "Sudah Dilepaskan",
    },
  ];
  let perPage = 10;

  const handleTabChange = (event, newTab) => {
    setExpanded(false);
    setTabActive(newTab);
  };

  function usePreviousTab(value) {
    const ref = React.useRef();
    React.useEffect(() => {
      ref.current = value;
    });

    return ref.current;
  }

  const collapsePanel = React.useCallback(
    (panel, expanded) => (event, isExpanded) => {
      setExpanded(isExpanded ? panel : false);
    },
    []
  );

  React.useEffect(() => {
    myIncomeActions.getReciveData();
  }, [myIncomeActions]);

  React.useEffect(() => {
    if (tabActive === 0) {
      const params = {
        num: perPage,
        sort: "newest",
        progress: "ready,complete",
      };
      myIncomeActions.getWillRelease(params);
    } else {
      const params = {
        num: perPage,
        keyword: search,
        date_start: dateRange.startDate,
        date_end: dateRange.endDate,
      };
      myIncomeActions.getHasRelease(params);
    }
  }, [myIncomeActions, tabActive, search, dateRange]);

  const getListWillReleaseData = () => {
    const params = {
      num: perPage,
      cursor: myIncomeState.header["x-cursor"],
      sort: "newest",
      progress: "",
    };
    myIncomeActions.getWillReleaseList(params);
  };

  const getListHasReleaseData = () => {
    const params = {
      num: perPage,
      cursor: myIncomeState.headerHasRelease["x-cursor"],
      keyword: search,
      date_start: dateRange.startDate,
      date_end: dateRange.endDate,
    };
    myIncomeActions.getHasReleaseList(params);
  };

  const handleDateChange = (val) => {
    let endDate = moment(val.endDate).format("YYYY-MM-DD") + " 23:59:59";
    let tStart = moment(val.startDate).tz("UTC").format();
    let tEnd = moment(endDate).tz("UTC").format();
    setDateRange({
      startDate: tStart,
      endDate: tEnd,
      key: val.key,
    });
  };

  return (
    <BaseLayout background="gray">
      <div className="row w-100">
        <div className="col-12">
          <h3 className="font-16 font-bold mb-3">Penghasilan Saya</h3>
        </div>
        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
          <div className="card card-body rounded-8px border-0 h-100">
            <h4 className="font-bold font-16">Dana yang didapatkan</h4>
            <span className="d-block font-12">Total</span>
            <h3 className="my-2 font-bold text-green font-20">
              {myIncomeState?.total_amount?.total_amount &&
                formatCurrency(
                  myIncomeState?.total_amount?.currency,
                  myIncomeState?.total_amount?.total_amount.toString()
                )}
            </h3>
          </div>
        </div>
        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
          <div className="card card-body rounded-8px border-0 h-100">
            <h4 className="font-bold font-16">Dana siap dicairkan</h4>
            <span className="d-block font-12">Total</span>
            <h3 className="my-2 font-bold text-green font-20">
              {myIncomeState?.saldo?.total_amount &&
                formatCurrency(
                  myIncomeState?.saldo?.currency,
                  myIncomeState?.saldo?.total_amount.toString()
                )}
            </h3>
            <button
              type="button"
              className="btn btn-block bg-blue font-12 rounded-8px mt-auto"
              onClick={() => {
                history.push("/saldosaya", {updateNav: true});
              }}
            >
              Saldo Penjual
            </button>
          </div>
        </div>
        <div className="col-lg-6 col-md-12 col-sm-12 mb-3">
          <div className="row h-100">
            <div className="col-lg-6 col-md-12 col-sm-12 mb-2">
              <div className="card card-body rounded-8px border-0 h-100">
                <h4 className="font-bold font-16">Refund</h4>
                <span className="d-block font-12">Rp. 0</span>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 mb-2">
              <div className="card card-body rounded-8px border-0 h-100">
                <h4 className="font-bold font-16">Rekening Bank Saya</h4>
                <span className="d-block font-12">
                  {myIncomeState?.rekening?.bank_account_number}
                </span>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="card card-body rounded-8px border-0 h-100">
                <h4 className="font-bold font-16">Penghasilan Saya</h4>
                <span className="d-block font-12">
                  {formatCurrency(
                      myIncomeState?.saldo?.currency || process.env.REACT_APP_CURRENCY_CODE,
                      (
                        (myIncomeState?.saldo?.total_amount || 0) +
                        (myIncomeState?.total_amount?.total_amount || 0)
                      ).toString()
                    )}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row w-100">
        <div className="col-12">
          <h3 className="font-16 font-bold my-3">Rincian Penghasilan</h3>
        </div>
        <div className="col-12"></div>
      </div>
      <Grid container className={classes.root}>
        <Grid item xs={12}>
          <StyledPaperTabs
            square
            style={{
              borderTopLeftRadius: 8,
              borderTopRightRadius: 8,
              paddingTop: 20,
            }}
          >
            <Grid container>
              <Grid item xs={5}>
                <Tabs
                  value={tabActive}
                  onChange={handleTabChange}
                  variant="scrollable"
                  scrollButtons="auto"
                >
                  {arrProcess.map((process, index) => {
                    return (
                      <StyledTab
                        key={index}
                        style={{ paddingBottom: 30 }}
                        label={process.label}
                      ></StyledTab>
                    );
                  })}
                </Tabs>
              </Grid>
              {tabActive === 1 && (
                <Grid item xs={7} container direction="row" justify="flex-end">
                  <SearchFilter
                    placeholder="Cari transaksi, nama"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                  <ButtonExport />
                  <DateRangePickerFilter
                    onChange={(val) => handleDateChange(val)}
                    defaultDate={dateRange}
                    maxDate={new Date()}
                  />
                </Grid>
              )}
            </Grid>
          </StyledPaperTabs>
        </Grid>
      </Grid>
      <Grid
        container
        className={classes.root}
        style={{ maxWidth: "100%", overflowX: "scroll" }}
      >
        <Grid
          item
          xs={12}
          style={{
            minWidth: 650,
          }}
        >
          <TableContainer>
            <StyledTable>
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell
                    style={{ backgroundColor: "#EEEEEE" }}
                    align="left"
                  >
                    No. Transaksi
                  </StyledTableCell>
                  <StyledTableCell
                    style={{ backgroundColor: "#EEEEEE" }}
                    align="left"
                  >
                    Nama Pembeli
                  </StyledTableCell>
                  <StyledTableCell
                    style={{ backgroundColor: "#EEEEEE" }}
                    align="left"
                  >
                    Tanggal Transaksi
                  </StyledTableCell>
                  <StyledTableCell
                    style={{ backgroundColor: "#EEEEEE" }}
                    align="left"
                  >
                    Perkiraan Dana Bisa di tarik
                  </StyledTableCell>
                  <StyledTableCell
                    style={{ backgroundColor: "#EEEEEE" }}
                    align="left"
                  >
                    Status
                  </StyledTableCell>
                  <StyledTableCell
                    style={{ backgroundColor: "#EEEEEE" }}
                    align="left"
                  >
                    Jumlah
                  </StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody style={{ background: "#FFFFFF" }}>
                {myIncomeState.isLoading
                  ? Array.from(new Array(10)).map((value, key) => {
                      return <ListPanelLoading key={key} id={key} />;
                    })
                  : myIncomeState.data.map((value, key) => {
                      return tabActive === 0 ? (
                        <ListPanel
                          collapsePanel={collapsePanel}
                          expanded={expanded}
                          id={key}
                          key={key}
                          transaction={value}
                          action={
                            tabActive ? arrProcess[tabActive] : arrProcess[0]
                          }
                          access={access}
                        />
                      ) : (
                        <ListPanelHasRelease
                          collapsePanel={collapsePanel}
                          expanded={expanded}
                          id={key}
                          key={key}
                          transaction={value}
                          action={
                            tabActive ? arrProcess[tabActive] : arrProcess[0]
                          }
                          access={access}
                        />
                      );
                    })}
              </TableBody>
            </StyledTable>
          </TableContainer>
          {!myIncomeState.isLoading && myIncomeState.data.length === 0 && (
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
              style={{ padding: 10 }}
            >
              <span className="font-12 text-muted">No History Data</span>
            </Grid>
          )}
          {myIncomeState.data.length >= perPage - 1 && perPage !== false && (
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
              style={{ padding: "10px" }}
            >
              {myIncomeState.lastPage ? (
                <h2>~</h2>
              ) : (
                <Button
                  onClick={() => {
                    tabActive === 0
                      ? getListWillReleaseData()
                      : getListHasReleaseData();
                  }}
                  size="small"
                  color="secondary"
                  variant="contained"
                  disabled={myIncomeState.isLoading}
                >
                  {myIncomeState.isLoading ? "Please Wait" : "Load More"}
                </Button>
              )}
            </Grid>
          )}
        </Grid>
      </Grid>
    </BaseLayout>
  );
};

export default MyIncome;
